import API from '../api/baseUrl'
import pathUrl from '../api/pathURL'
import { LogType } from '../types/interface'
import { getAuthToken } from './auth-token'

const createLog = async (payload: LogType) => {
  try {
    const token = await getAuthToken()
    const options = {
      // Set options
      headers: {
        Authorization: token,
        ...(import.meta.env.MODE && { env: import.meta.env.MODE }),
      },
    }
    const response = await API.post(pathUrl.createLog, { ...payload }, options) // Add vehicle photo
    const data = await response.data
    if (data) {
      return data
    }

    return null
  } catch (error) {
    console.log(error)
    return error
  }
}

export { createLog }
